import { AddCircleOutlineOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

import HNSColors from "../../../ui library/HNSColors";

export default function PaymentsAddButton({ handleAdd }) {
  return (
    <Button
      variant="contained"
      color="primary"
      onClick={handleAdd}
      className="max-w-50 min-w-40 normal-case"
      endIcon={<AddCircleOutlineOutlined />}
      sx={{
        borderRadius: "500px",
        color: HNSColors.neutrals[900],
        backgroundColor: HNSColors.secondary[500],
        "&:hover": {
          background: HNSColors.secondary[600],
          color: HNSColors.neutrals[900],
        },
      }}
    >
      Add Payment
    </Button>
  );
}
